import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchDistrict, fetchProvinces, fetchWards } from "../../../store/action/addressAction";
import { changeValue } from "../../../store/action/cartAction";

const OrderInfo = (props) => {
   const { carts, address, changeValue, fetchDistrict, fetchProvinces, fetchWards } = props;
   const { provinces, districts, wards } = address;
   const [isShowProvinces, setIsShowProvinces] = useState(false);
   const [isShowDistricts, setIsShowDistricts] = useState(false);
   const [isShowWards, setIsShowWards] = useState(false);

   const onChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      changeValue(name, value)
   }

   useEffect(() => {
      fetchProvinces(238);
      changeValue("shipping_country", 238);
      changeValue("shipping_country_name", "Việt Nam");
      changeValue("shipping_method_name", "Giao hàng tận nơi");
      changeValue("shipping_method_id", 0);
      changeValue("payment_method_name", "Thanh toán khi giao hàng (COD)");
      changeValue("payment_method_id", 0);
   }, []);

   const handleShowProvinces = (boolean = false) => {
      setIsShowProvinces(boolean);
      setIsShowDistricts(false);
      setIsShowWards(false);
      if (!provinces.length) {
         fetchProvinces(238);
      }
   }

   const handleShowDistricts = (boolean = false) => {
      setIsShowProvinces(false);
      setIsShowDistricts(boolean);
      setIsShowWards(false);
      if (!districts.length && carts.shipping_province) {
         fetchDistrict(carts.shipping_province);
      }
   }

   const handleShowWards = (boolean = false) => {
      setIsShowProvinces(false);
      setIsShowDistricts(false);
      setIsShowWards(boolean);
      if (!wards.length && carts.shipping_district) {
         fetchWards(carts.shipping_district);
      }
   }

   const handleSelectProvinces = (item) => {
      changeValue("shipping_province", item.id);
      changeValue("shipping_province_name", item.name_vi);
      changeValue("shipping_district", undefined);
      changeValue("shipping_district_name", undefined);
      changeValue("shipping_ward", undefined);
      changeValue("shipping_ward_name", undefined);
      handleShowProvinces(false);
      fetchDistrict(item.id);
   }

   const handleSelectDistricts = (item) => {
      changeValue("shipping_district", item.id);
      changeValue("shipping_district_name", item.name_vi);
      changeValue("shipping_ward", undefined);
      changeValue("shipping_ward_name", undefined);
      handleShowProvinces(false);
      fetchWards(item.id);
   }

   const handleSelectWards = (item) => {
      changeValue("shipping_ward", item.id);
      changeValue("shipping_ward_name", item.name_vi);
      handleShowProvinces(false);
   }

   return (
      <div className="list-cart-container" >
         <div className="header-infor-address">
            <div className="title-container">
               <div className="svg-next-icon icon-title" >
               </div>
               <span className="title">Thông tin giao hàng</span>
            </div>
         </div>
         <div className="shipment-detail-container ">
            <div className="info-shipment-container">
               <div className="input-container">
                  <span className="title-input">Họ và tên</span>
                  <input
                     placeholder="Nhập Họ và tên"
                     className="app-next-input input-shipment"
                     name="shipping_full_name"
                     type="text"
                     value={carts.shipping_full_name}
                     onChange={onChange}
                  />
               </div>
               <div className="input-container">
                  <span className="title-input">Số điện thoại</span>
                  <input
                     className="app-next-input input-shipment"
                     placeholder="Nhập Số điện thoại"
                     name="shipping_phone"
                     type="text"
                     value={carts.shipping_phone}
                     onChange={onChange} />
               </div>
               <div className="input-container">
                  <div className="address-wrapper-shipment">
                     <div className="input-container">
                        <span className="title-input">Địa chỉ </span>
                        <input
                           className="app-next-input input-shipment"
                           placeholder="Địa chỉ"
                           name="shipping_address"
                           value={carts.shipping_address}
                           onChange={onChange} />
                     </div>
                     <div className="input-container">
                        <span className="title-input">Tỉnh/Thành </span>
                        <div className="app-form-group">
                           <div className="app-select app-select-enabled" onClick={() => handleShowProvinces(!isShowProvinces)}>
                              <div className="app-select-selection app-select-selection--single" role="combobox" tabIndex="0">
                                 <div className="app-select-selection__rendered">
                                    {carts.shipping_province_name ?
                                       <div className="app-select-selection-selected-value" title="Hà Nội" >
                                          {carts.shipping_province_name}
                                       </div>
                                       :
                                       <div unselectable="on" className="app-select-selection__placeholder" >
                                          Chọn Tỉnh/Thành
                                       </div>
                                    }
                                 </div>
                                 <span className="app-select-arrow" unselectable="on">
                                    <svg className="app-svg-inline-block app-svg-next-icon-rotate-90 app-select-arrow-icon" width="16px" height="16px" viewBox="0 0 16 16">
                                       <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                                       </path>
                                    </svg>
                                 </span>
                              </div>
                              {isShowProvinces &&
                                 <div className="app-select-dropdown app-select-dropdown--single app-select-dropdown-placement-bottomLeft select-option-container">
                                    <div>
                                       <ul role="listbox" className="app-select-dropdown-menu  app-select-dropdown-menu-root app-select-dropdown-menu-vertical" tabIndex="0">
                                          {provinces.map((item, index) => {
                                             return (
                                                <li role="option"
                                                   className={`app-select-dropdown-menu-item ${item.id == carts.shipping_province && "app-select-dropdown-menu-item-selected app-select-dropdown-menu-item-active"}`}
                                                   key={index}
                                                   onClick={() => {
                                                      handleSelectProvinces(item)
                                                   }}
                                                >
                                                   {item.name_vi}
                                                </li>
                                             )
                                          })}
                                       </ul>
                                    </div>
                                 </div>
                              }
                           </div>
                        </div>
                     </div>
                     <div className="input-container">
                        <span className="title-input">Quận/Huyện </span>
                        <div className="app-form-group">
                           <div className="app-select app-select-enabled" onClick={() => handleShowDistricts(!isShowDistricts)}>
                              <div className="app-select-selection app-select-selection--single" role="combobox" tabIndex="0">
                                 <div className="app-select-selection__rendered">
                                    {carts.shipping_district_name ?
                                       <div className="app-select-selection-selected-value" title="Hà Nội" >
                                          {carts.shipping_district_name}
                                       </div>
                                       :
                                       <div unselectable="on" className="app-select-selection__placeholder" >
                                          Chọn Quận/Huyện
                                       </div>
                                    }
                                 </div>
                                 <span className="app-select-arrow" unselectable="on">
                                    <svg className="app-svg-inline-block app-svg-next-icon-rotate-90 app-select-arrow-icon" width="16px" height="16px" viewBox="0 0 16 16">
                                       <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                                       </path>
                                    </svg>
                                 </span>
                              </div>
                              {isShowDistricts &&
                                 <div className="app-select-dropdown app-select-dropdown--single app-select-dropdown-placement-bottomLeft select-option-container">
                                    <div>
                                       <ul role="listbox" className="app-select-dropdown-menu  app-select-dropdown-menu-root app-select-dropdown-menu-vertical" tabIndex="0">
                                          {districts.map((item, index) => {
                                             return (
                                                <li role="option"
                                                   className={`app-select-dropdown-menu-item ${item.id == carts.shipping_district && "app-select-dropdown-menu-item-selected app-select-dropdown-menu-item-active"}`}
                                                   key={index}
                                                   onClick={() => {
                                                      handleShowDistricts(false)
                                                      handleSelectDistricts(item)
                                                   }}>
                                                   {item.name_vi}
                                                </li>
                                             )
                                          })}
                                       </ul>
                                    </div>
                                 </div>
                              }
                           </div>
                        </div>
                     </div>
                     <div className="input-container">
                        <span className="title-input">Phường/Xã </span>
                        <div className="app-form-group">
                           <div className="app-select app-select-enabled" onClick={() => handleShowWards(!isShowWards)}>
                              <div className="app-select-selection app-select-selection--single" role="combobox" tabIndex="0">
                                 <div className="app-select-selection__rendered">
                                    {carts.shipping_ward_name ?
                                       <div className="app-select-selection-selected-value" title="Hà Nội" >
                                          {carts.shipping_ward_name}
                                       </div>
                                       :
                                       <div unselectable="on" className="app-select-selection__placeholder" >
                                          Chọn Phường/Xã
                                       </div>
                                    }
                                 </div>
                                 <span className="app-select-arrow" unselectable="on">
                                    <svg className="app-svg-inline-block app-svg-next-icon-rotate-90 app-select-arrow-icon" width="16px" height="16px" viewBox="0 0 16 16">
                                       <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                                       </path>
                                    </svg>
                                 </span>
                              </div>
                              {isShowWards &&
                                 <div className="app-select-dropdown app-select-dropdown--single app-select-dropdown-placement-bottomLeft select-option-container">
                                    <div>
                                       <ul role="listbox" className="app-select-dropdown-menu  app-select-dropdown-menu-root app-select-dropdown-menu-vertical" tabIndex="0">
                                          {wards.map((item, index) => {
                                             return (
                                                <li role="option"
                                                   className={`app-select-dropdown-menu-item ${item.id == carts.shipping_ward && "app-select-dropdown-menu-item-selected app-select-dropdown-menu-item-active"}`}
                                                   key={index}
                                                   onClick={() => {
                                                      handleShowWards(false);
                                                      handleSelectWards(item)
                                                   }}>
                                                   {item.name_vi}
                                                </li>
                                             )
                                          })}
                                       </ul>
                                    </div>
                                 </div>
                              }
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div >
   );
}

const mapStateToProps = (state) => {
   const { carts, address } = state;
   return {
      carts,
      address
   };
};

export default connect(mapStateToProps, {
   changeValue,
   fetchDistrict,
   fetchProvinces,
   fetchWards
})(OrderInfo);
